// extracted by mini-css-extract-plugin
export var logo = "_lb-2";
export var logoWrapper = "_lb-1";
export var strip = "_lb-0";